import { z } from 'zod';
import { PASSWORD_POLICY_RE } from './password-policy';

export const resetPasswordStep1Schema = z.object({
	email: z
		.string()
		.min(1, 'validation:auth.email.required')
		.email('auth:resetPassword.errors.emailInvalid'),
});

export const resetPasswordStep2Schema = z.object({
	code: z
		.string()
		.min(1, 'validation:auth.codeRequired')
		.length(6, 'validation:auth.codeInvalid'),
});

export const resetPasswordStep3Schema = z
	.object({
		password: z
			.string()
			.max(64, 'validation:auth.passwordLengthRule')
			.regex(PASSWORD_POLICY_RE, 'validation:auth.passwordRule'),
		confirmPassword: z.string(),
	})
	.refine((data) => data.password === data.confirmPassword, {
		message: 'validation:auth.passwordMismatch',
		path: ['confirmPassword'],
	});

export type ResetPasswordStep1Values = z.infer<typeof resetPasswordStep1Schema>;
export type ResetPasswordStep2Values = z.infer<typeof resetPasswordStep2Schema>;
export type ResetPasswordStep3Values = z.infer<typeof resetPasswordStep3Schema>;
